import { UPDATE_SEARCHTDATA_DANHSACHKIEMKHO } from "../../actions/DanhSachKiemKho/actionTypes";

const initialState = {
  makiemkho: "",
  nguoikiemkho: "",
  tuNgay: "01/01/2001",
  denNgay: "01/01/4000",
};

const updateDataSearch = (state, action) => ({
  ...action.payload,

  //matentaisan: action.payload.matentaisan,
  //searchText: action.payload,
});

export const dataSearchDanhSachKiemKho = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCHTDATA_DANHSACHKIEMKHO:
      return updateDataSearch(state, action);
    default:
      return state;
  }
};

export default dataSearchDanhSachKiemKho;
